(() => {
  function initTileCalculator(root) {
    const scope = root || document;
    const qtyInput = scope.querySelector('.quantity__input');
    const coverageInput = scope.querySelector('.coverage__input');
    const totalEl = scope.querySelector('#TotalPrice');

    if (!qtyInput || !coverageInput || !totalEl) return;
    if (qtyInput.dataset.tcalcInit === 'true') return;
    qtyInput.dataset.tcalcInit = 'true';
    // console.log('[tile_calc] init', { qtyInput, coverageInput, totalEl });

    const cfg = window.tileCalculator || {};
    const tileWidth = Number(cfg.tileWidth) || 0;
    const tileLength = Number(cfg.tileLength) || 0;
    const unitAreaM2 = Number(cfg.unitAreaM2) || 0;
    const tilesPerM2 = Number(cfg.tilesPerM2) || 0;
    const packSize = Number(cfg.packSize) || 1;
    const tileBundle = String(cfg.tileBundle || '').toLowerCase();
    const priceCents = Number(cfg.price) || 0;
    const moneyFormat = cfg.moneyFormat || "£{{amount}}";
    const hasType = tileBundle.length > 0;
    const isLinear = tileBundle === 'linear';
    const isWall = tileBundle === 'wall';
    const isLinearOrWall = isLinear || isWall;
    const linearUnitSize = Number(cfg.linearUnitSize) || 0;

  let tileAreaM2 = (tileWidth && tileLength)
    ? (tileWidth * tileLength) / 1000000
    : unitAreaM2;
  if ((!tileAreaM2 || tileAreaM2 <= 0) && tilesPerM2 > 0) {
    tileAreaM2 = 1 / tilesPerM2;
  }
  if (!tileAreaM2 || tileAreaM2 <= 0) {
    tileAreaM2 = 0.01;
  }
  // Linear tiles: use the tile's width_m metafield (sold by length).
  // Wall tiles: use unit_area_m2 directly (sold by area) — same downstream
  // button/rounding logic as linear, just a different source metafield.
  if (isLinear && linearUnitSize > 0) {
    tileAreaM2 = linearUnitSize;
  } else if (isWall && unitAreaM2 > 0) {
    tileAreaM2 = unitAreaM2;
  }

  function roundUpToStep(value, step) {
    return Math.ceil(value / step) * step;
  }

  function formatCoverage(value) {
    let v = Number(value);
    if (!isFinite(v) || isNaN(v)) v = 0;
    if (isLinearOrWall) {
      const rounded = (v + 1e-9).toFixed(2);
      return rounded.endsWith('.00') ? rounded.slice(0, -3) : rounded;
    }
    const fixed = v.toFixed(2);
    return fixed.replace(/\.?0+$/, '');
  }

  function formatPrice(priceCents, moneyFormat) {
    let amount = Number(priceCents) / 100;
    if (!isFinite(amount) || isNaN(amount)) amount = 0;
    return moneyFormat.replace("{{amount_no_decimals}}", Math.round(amount))
                      .replace("{{amount}}", amount.toFixed(2));
  }

  const isFixedTileOrPack = tileBundle === 'fixed pack' || tileBundle === 'fixed tile';
  const minCoverage = 1;
  let allowBelowCoverageMin = false;
  let qtyStep = tileBundle === 'fixed pack' ? packSize : (Number(qtyInput.step) || 1);
  let minQtyFromCoverage = roundUpToStep(Math.ceil(minCoverage / tileAreaM2), qtyStep);
  let minQty = Math.max(1, Number(qtyInput.min) || 1, minQtyFromCoverage);
  let minQtyFloor = Math.max(1, Number(qtyInput.min) || 1);

  function refreshLimits() {
    qtyStep = tileBundle === 'fixed pack' ? packSize : (Number(qtyInput.step) || 1);
    minQtyFromCoverage = roundUpToStep(Math.ceil(minCoverage / tileAreaM2), qtyStep);
    minQty = Math.max(1, Number(qtyInput.min) || 1, minQtyFromCoverage);
    minQtyFloor = Math.max(1, Number(qtyInput.min) || 1);
  }

  function enableBelowMinCoverage() {
    if (!hasType) allowBelowCoverageMin = true;
  }

  function getMinCoverage() {
    return allowBelowCoverageMin ? 0 : minCoverage;
  }

  let rawCoverageValue = 0;

  function updateCoverage() {
    const qty = Number(qtyInput.value) || minQty;
    if (!hasType) {
      if (allowBelowCoverageMin) {
        const coverageInt = Math.round(qty * tileAreaM2);
        rawCoverageValue = coverageInt;
        coverageInput.value = coverageInt;
        // console.log('[tile_calc] updateCoverage no-type', { qty, coverage: coverageInput.value });
        return;
      }
      const coverageInt = Math.round(qty * tileAreaM2);
      rawCoverageValue = coverageInt;
      coverageInput.value = coverageInt;
      const adjustedQty = Math.round(coverageInt / tileAreaM2);
      if (adjustedQty !== qty) qtyInput.value = adjustedQty;
      // console.log('[tile_calc] updateCoverage no-type', { qty, coverageInt, adjustedQty });
      return;
    }
    rawCoverageValue = qty * tileAreaM2;
    // console.log('[tile_calc] updateCoverage', { qty, coverage: coverageInput.value });
    coverageInput.value = formatCoverage(rawCoverageValue);
  }

  function updateQuantityFromCoverage(fromCoverageBtn = false) {
    const coverage = rawCoverageValue || Number(coverageInput.value) || 0;
    let qty = coverage / tileAreaM2;

    if (fromCoverageBtn) {
      qtyInput.value = Math.max(minQtyFloor, Math.round(qty));
    } else {
      const floor = allowBelowCoverageMin ? minQtyFloor : minQty;
      qtyInput.value = Math.max(floor, roundUpToStep(Math.ceil(Number(qty.toFixed(10))), qtyStep));
    }
  }

  function updateTotal() {
    const qty = Number(qtyInput.value) || 0;
    totalEl.textContent = formatPrice(priceCents * qty, moneyFormat);
    // console.log('[tile_calc] updateTotal', { qty, total: totalEl.textContent });
  }

    const qtyMinusBtn = scope.querySelector('.tcalc-btn--qty-minus') || qtyInput.closest('.quantity')?.querySelector('button[name="minus"]');
    const qtyPlusBtn = scope.querySelector('.tcalc-btn--qty-plus') || qtyInput.closest('.quantity')?.querySelector('button[name="plus"]');
    const covMinusBtn = scope.querySelector('.tcalc-btn--cov-minus');
    const covPlusBtn = scope.querySelector('.tcalc-btn--cov-plus');

  function increaseQty() {
    enableBelowMinCoverage();
    let val = Number(qtyInput.value) || minQty;
    qtyInput.value = val + qtyStep;
    updateCoverage();
    updateTotal();
  }

  function decreaseQty() {
    enableBelowMinCoverage();
    const floor = isFixedTileOrPack ? minQtyFloor : (allowBelowCoverageMin ? minQtyFloor : minQty);
    let val = Number(qtyInput.value) || floor;
    val = val - qtyStep;
    if (val < floor) val = floor;
    qtyInput.value = val;
    updateCoverage();
    updateTotal();
  }

  function increaseCoverage() {
    enableBelowMinCoverage();
    const minCov = getMinCoverage();
    let val = rawCoverageValue || Number(coverageInput.value) || minCov;
    val = val + (tileAreaM2 * qtyStep);
    rawCoverageValue = val;
    coverageInput.value = formatCoverage(val);
    updateQuantityFromCoverage(true);
    updateTotal();
  }

  function decreaseCoverage() {
    enableBelowMinCoverage();
    const minCov = tileAreaM2 * qtyStep;
    let val = rawCoverageValue || Number(coverageInput.value) || minCov;
    val = val - (tileAreaM2 * qtyStep);
    if (val < minCov) val = minCov;
    rawCoverageValue = val;
    coverageInput.value = formatCoverage(val);
    updateQuantityFromCoverage(true);
    updateTotal();
  }

  // ── Linear-specific step functions: always move by exactly one tile's width,
  // coverage always shown at 2dp, qty is always a whole tile
  function increaseLinearQty() {
    const qty = (Number(qtyInput.value) || 1) + 1;
    qtyInput.value = qty;
    rawCoverageValue = qty * tileAreaM2;
    coverageInput.value = formatCoverage(rawCoverageValue);
    updateTotal();
  }

  function decreaseLinearQty() {
    const qty = Math.max(1, (Number(qtyInput.value) || 1) - 1);
    qtyInput.value = qty;
    rawCoverageValue = qty * tileAreaM2;
    coverageInput.value = formatCoverage(rawCoverageValue);
    updateTotal();
  }

  function increaseLinearCoverage() {
    const qty = (Number(qtyInput.value) || 1) + 1; // + button always moves 1 whole tile
    qtyInput.value = qty;
    rawCoverageValue = qty * tileAreaM2;
    coverageInput.value = formatCoverage(rawCoverageValue);
    updateTotal();
  }

  function decreaseLinearCoverage() {
    const qty = Math.max(1, (Number(qtyInput.value) || 1) - 1);
    qtyInput.value = qty;
    rawCoverageValue = qty * tileAreaM2;
    coverageInput.value = formatCoverage(rawCoverageValue);
    updateTotal();
  }

  function bindButton(btn, handler) {
    if (!btn) return;
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      handler();
    });
  }

    if (isLinearOrWall) {
      bindButton(qtyPlusBtn, increaseLinearQty);
      bindButton(qtyMinusBtn, decreaseLinearQty);
      bindButton(covPlusBtn, increaseLinearCoverage);
      bindButton(covMinusBtn, decreaseLinearCoverage);
    } else {
      bindButton(qtyPlusBtn, increaseQty);
      bindButton(qtyMinusBtn, decreaseQty);
      bindButton(covPlusBtn, increaseCoverage);
      bindButton(covMinusBtn, decreaseCoverage);
    }

    qtyInput.addEventListener('change', () => {
    if (isLinearOrWall) {
      let val = Math.round(Number(qtyInput.value)) || 1;
      val = Math.max(1, val);
      qtyInput.value = val;
      rawCoverageValue = val * tileAreaM2;
      coverageInput.value = formatCoverage(rawCoverageValue);
      updateTotal();
      return;
    }
    enableBelowMinCoverage();
    let val = Number(qtyInput.value) || 0;
    // console.log('[tile_calc] qty change start', { val });
    const floor = isFixedTileOrPack ? minQtyFloor : (allowBelowCoverageMin ? minQtyFloor : minQty);
    if (val < floor) val = floor;
    if (qtyStep > 1) {
      val = roundUpToStep(Math.ceil(val), qtyStep);
    }
    qtyInput.value = val;
    updateCoverage();
    updateTotal();
    // console.log('[tile_calc] qty change end', { val: qtyInput.value, coverage: coverageInput.value });
  });

    coverageInput.addEventListener('change', () => {
    if (isLinearOrWall) {
      let val = Number(coverageInput.value) || 0;
      if (val < 0) val = 0;
      const qty = Math.max(1, Math.round(val / tileAreaM2));
      qtyInput.value = qty;
      rawCoverageValue = qty * tileAreaM2;
      coverageInput.value = formatCoverage(rawCoverageValue);
      updateTotal();
      return;
    }
    enableBelowMinCoverage();
    const minCov = getMinCoverage();
    let val = Number(coverageInput.value) || 0;
    // console.log('[tile_calc] coverage change start', { val });
    if (val < minCov) val = minCov;
    rawCoverageValue = val;
    if (!hasType) {
      if (allowBelowCoverageMin) {
        const coverageInt = Math.round(val);
        coverageInput.value = coverageInt;
        qtyInput.value = Math.max(minQtyFloor, Math.round(coverageInt / tileAreaM2));
      } else {
        const coverageInt = Math.max(minCoverage, Math.round(val));
        coverageInput.value = coverageInt;
        qtyInput.value = Math.round(coverageInt / tileAreaM2);
      }
      updateTotal();
      // console.log('[tile_calc] coverage change end no-type', { coverage: coverageInput.value, qty: qtyInput.value });
      return;
    }
    coverageInput.value = formatCoverage(val);
    updateQuantityFromCoverage();
    updateCoverage();
    updateTotal();
    // console.log('[tile_calc] coverage change end', { coverage: coverageInput.value, qty: qtyInput.value });
  });

    if (!qtyInput.value || Number(qtyInput.value) < minQty) {
      qtyInput.value = minQty;
    }
    updateCoverage();
    updateTotal();

    // Linear default: smallest whole number of tiles that covers at least 1 linear
    // metre, with the displayed coverage derived from that exact tile count (2dp).
    if (isLinearOrWall) {
      const defaultQty = Math.max(1, Math.ceil(1 / tileAreaM2));
      qtyInput.value = defaultQty;
      rawCoverageValue = defaultQty * tileAreaM2;
      coverageInput.value = formatCoverage(rawCoverageValue);
      updateTotal();
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        refreshLimits();
        updateCoverage();
        updateTotal();
        // console.log('[tile_calc] variant change sync', { qty: qtyInput.value, coverage: coverageInput.value });
      });
    }
  }

  window.initTileCalculator = initTileCalculator;

  document.addEventListener('DOMContentLoaded', () => {
    initTileCalculator(document);
  });
})();
